
import { Button, Col, List, Modal, Row, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import servicePath from '../../config/apiUrl';
import '../../static/css/CameraList.css';
const { confirm } = Modal;

function AdlList(props) {

  const [list, setList] = useState([])
  //得到文章列表
  const getList = () => {
    const key = 'getList';

    message.loading({ content: '加载数据...', key });
    axios({
      method: 'get',
      url: servicePath.getNoticelList,
      withCredentials: true,
      header: { 'Access-Control-Allow-Origin': '*' }
    }).then(
      res => {
        if (res.data.code == 1) {
          setList(res.data.list)
          message.success({ content: '加载数据成功！', key, duration: 2 });
        } else {
          message.error({ content: '加载数据失败！', key, duration: 2 });
        }
      }
    ).catch((res) => {
      console.log("err", res)
      message.error({ content: '加载数据失败！', key, duration: 2 });
    })
  }
  useEffect(() => {
    getList()
  }, [])


  //删除公告
  const deleteAdInfo = (id) => {
    confirm({
      title: '确定要删除该公告信息吗?',
      content: '如果你点击OK按钮，将会永远被删除，无法恢复。',
      onOk() {
        axios(servicePath.deleteNoticeInfo + '/' + id, { withCredentials: true }).then(
          res => {
            message.success('公告删除成功')
            getList()
          }
        )
      },
      onCancel() {
        message.info('取消删除')
      },
    });

  }
  //修改公告
  const editAdInfo = (id, checked) => {
    props.history.push('/notice/editNotice/' + id)
  }

  return (
    <div>
      <List
        header={
          <Row className="list-div">
            <Col span={2}>
              <b>公告ID</b>
            </Col>
            <Col span={6}>
              <b>标题</b>
            </Col>
            <Col span={11}>
              <b>内容</b>
            </Col>

            <Col span={2}>
              <b>是否展示</b>
            </Col>
            <Col span={3}>
              <b>操作</b>
            </Col>
          </Row>

        }
        bordered
        dataSource={list}
        renderItem={item => (
          <List.Item>
            <Row className="list-div">
              <Col span={2}>
                {item.adId}
              </Col>
              <Col span={6}>
                <div className='des_text'>
                  {item.title}
                </div>
              </Col>
              <Col span={11}>
                <div className='des_text'>
                  {item.rich_text_content}...
                </div>
              </Col>
              <Col span={2}>
                {item.hide == 1 ? '不展示' : "展示"}
              </Col>
              <Col span={3} >
                <Button type="primary" onClick={() => { editAdInfo(item.adId) }}>修改</Button>
                <Button style={{ marginLeft: '16px' }} onClick={() => { deleteAdInfo(item.adId) }}>删除</Button>
              </Col>
            </Row>

          </List.Item>
        )}
      />

    </div>
  )

}

export default AdlList